import { Box } from '@mui/material';
import { useState } from 'react';
import { Document, DocumentProps, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import {
  DocumentCallback,
  OnDocumentLoadSuccess,
} from 'react-pdf/dist/cjs/shared/types';

import { APP_ENV } from '../../../configs';

pdfjs.GlobalWorkerOptions.workerSrc = `${APP_ENV.PUBLIC_URL}/pdf.worker.min.js`;
// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function PdfReader({ file }: DocumentProps) {
  const [loadedPdf, setLoadedPdf] = useState<DocumentCallback>();

  const [prevFile, setPrevFile] = useState<DocumentProps['file']>();
  if (prevFile !== file) {
    setPrevFile(file);
    setLoadedPdf(undefined);
  }
  const onDocumentLoadSuccess: OnDocumentLoadSuccess = (pdf) => {
    setLoadedPdf(pdf);
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
        {loadedPdf && loadedPdf?.numPages && loadedPdf?.numPages > 0 && (
          <Box
            sx={{
              flex: 1,
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              justifyContent: 'start',
              alignItems: 'start',
              minWidth: 'min-content',
              maxHeight: 'max-content',
              // padding: 2,
            }}
          >
            {Array.from(new Array(loadedPdf.numPages), (el, index) => (
              <Page key={'page_' + index} pageIndex={index} />
            ))}
          </Box>
        )}
      </Document>
    </Box>
  );
}
